import dayjs from 'dayjs'
import Module from '../Module';
import Item from "../parts/Item";

export default class Diverse extends Module {
    constructor(title, index, tdoDescription, options, showInTraveldateOffer, keepActiveAfterTraveldateOffer, checkin, checkout) {
        // Chain constructor with super
        super(title, index, 'diverse');
        this._title = title || 'Ihre Anfrage';
        this._options = options;
        this._models = {};
        this._showInTraveldateOffer = showInTraveldateOffer || false;
        this._keepActiveAfterTraveldateOffer = keepActiveAfterTraveldateOffer || false;
        this._defaultDatepickerText = null // 'Tag auswählen';
        this._setPresetDatesFromConfigOrQueryParams({
            checkin: checkin,
            checkout: checkout,
        })
        this._checkin = '';
        this._checkout = '';
        //text for datepicker
        this._text = this._defaultDatepickerText;
        this._items = [];
        this.buildStructure();
        this.tdoDescription = tdoDescription;
    }

    buildStructure = function () {
        const that = this;
        this._options.forEach(function (element, key) {
            if (typeof element.name == 'undefined') {
                element.name = 'blocks[' + that.index + key + '][value]';
                const label = 'blocks[' + that.index + key + '][label]';
                that._models[label] = {};
                that._models[label].value = element.title;
                that._models[label].type = 'hidden';
                that._models[label].error = false;
            } else if (element.name === 'service') {
                const label = 'ii_service';
                that._models[label] = {};
                that._models[label].value = element.title;
                that._models[label].type = 'hidden';
                that._models[label].error = false;
            }
            that._models[element.name] = {};
            that._models[element.name].error = false;
            that._models[element.name].value = "";
            that._models[element.name].title = element.title;
            that._models[element.name].summary_title = element.summary_title;
            that._models[element.name].type = element.type;
            that._models[element.name].index = that.index + '' + key;
            that._models[element.name].mandatory = element.mandatory;
            if (element.value) {
                switch (element.value) {
                    case '[document.referrer]':
                        that._models[element.name].value = document.referrer;
                        break;
                    default:
                        that._models[element.name].value = element.value;
                }
            }
            switch (element.type) {
                case 'checkbox':
                    that._models[element.name].value = [];
                    break;
                case 'datepicker':
                    that._models[element.name].time = element.time;
                    break;
                case 'people':
                    that._items.push(new Item(0, '', 0, element.config));
                    break;
            }
        });
    };

    updatePicker(start, end, key, isSingle) {
        const option = this.models[key]
        const startMoment = dayjs(start)
        const formatDay = 'DD.MM.YYYY';
        const formatDayWithTime = formatDay + " - HH:mm [Uhr]";
        if (isSingle) {
            this.text = startMoment.format(option.time ? formatDayWithTime : formatDay);
        } else {
            const endMoment = dayjs(end)
            this.text = startMoment.format(formatDay) + ' - ' + endMoment.format(formatDay);
        }
        option.value = this.text;
    }

    setModel(model) {
        this._models[model.name] = model;
    }

    removeModel(key) {
        delete this._models[key];
    }

    get models() {
        return this._models;
    }

    set models(value) {
        this._models = value;
    }

    get title() {
        return this._title;
    }

    get options() {
        return this._options;
    }

    get checkin() {
        return this._checkin;
    }

    set checkin(checkin) {
        this._checkin = checkin;
    }

    get checkout() {
        return this._checkout;
    }

    set checkout(checkout) {
        this._checkout = checkout;
    }

    get text() {
        return this._text;
    }

    set text(text) {
        this._text = text;
    }

    addItem(adults, category, index) {
        const newItem = new Item(adults, category, index);
        this._items.push(newItem);
        return newItem;
    }

    removeItem(index) {
        this._items.splice(index, 1);
    }

    getItemByIndex(index) {
        return this._items[index];
    }

    get items() {
        return this._items;
    }

    get showInTraveldateOffer() {
        return this._showInTraveldateOffer;
    }
    get keepActiveAfterTraveldateOffer() {
        return this._keepActiveAfterTraveldateOffer;
    }
    /* either take it from config.checkin / config.checkout or GET param checkin, checkout */
    tryToPresetDates(store, name, isSingle) {
        const checkin = this._presetDates.checkin;
        const checkout = this._presetDates.checkout;
        if (checkin || checkout) {
            this.setDates(store, name, isSingle, checkin, checkout);
        }
    }

    fillDummyData(store) {
    }

    setDates(store, name, isSingle, checkin, checkout) {
        this.checkin = checkin;
        this.checkout = checkout;
        this.updatePicker(checkin, checkout, name, isSingle);
    }

    removeDummyData() {
    }
}